/* GIANT Recovery Ball: shared behaviour for the GIANT layout. No dependencies.
   Section-specific scripts (carousel, sticky buy bar) live in their section files.
     [data-buy-form]  a hidden Shopify product form; its Buy now buttons point at it
                      with form="…". On submit the cart is emptied first so checkout
                      always holds exactly one ball, then the form posts to /cart/add
                      and Shopify redirects straight to /checkout (return_to). */
(function () {
  "use strict";

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ---------- Buy now → straight to checkout ---------- */
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form.matches || !form.matches("[data-buy-form]") || form.dataset.submitting) return;
    ev.preventDefault();
    form.dataset.submitting = "1";
    document.querySelectorAll('[form="' + form.id + '"]').forEach(function (b) { b.setAttribute("aria-busy", "true"); });

    fetch(root + "cart/clear.js", { method: "POST", headers: { "Accept": "application/json" } })
      .catch(function () {})
      .then(function () { form.submit(); });
  });

  // Back/forward cache: re-enable buttons if the shopper returns from checkout.
  window.addEventListener("pageshow", function () {
    document.querySelectorAll("[data-buy-form]").forEach(function (f) { delete f.dataset.submitting; });
    document.querySelectorAll('[aria-busy="true"]').forEach(function (b) { b.removeAttribute("aria-busy"); });
  });

  /* ---------- Scroll reveal ---------- */
  if (designMode || !("IntersectionObserver" in window)) return;

  document.documentElement.classList.add("js");
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
})();
